import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import { Col, Container, Overlay, Popover, Row, Table } from "react-bootstrap";
import { commonService } from "../../utils/commonService";
import { checkValidation } from "../../utils/helper";
import { validationRule } from "../../utils/constant";
import moment from "moment";
import Non_WidgetDetailModal from "./NonWidgetDetailModal";
import AddRoomDistributionModal from "./AddRoomDistributionModal";
import infoIcon from "../../Assets/Images/Action Icons/infoIcon..svg";
import Success from "../../Assets/Images/Success.svg";
import Error from "../../Assets/Images/Error.svg";
import divide from "../../Assets/Images/divide.svg";
import SingleDateSummaryModal from "./SingleDateSummaryModal";
import SingleDayGroupModal from "./SingleDayGroupModal";
import EventViewModal from "../CommonComponent/EventViewModal";
import ticket from "../../Assets/Images/Revenue-management/tableTicket.svg";
import "../../Assets/Styles/DisplacementCalc.css";


const DisplacementCalc = ({ api, para, setting }) => {
    const [widgetModal, setWidgetModal] = useState(false);
    const [showRoomDistributionModal, setShowRoomDistributionModal] = useState(false);

    const singleDatePickupDateRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const selectedTdIndexRef = useRef();
    const eventListRef = useRef();



    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const closeRoomDistributionModal = () => {
        setShowRoomDistributionModal(false);
    };

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });
    const handleFilterBtnClick = (event) => {
        // let screenY = event.screenY;
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        // let Left = event.nativeEvent.layerX + 30;
        if (Top + 400 > window.innerHeight) {
            // Top = Top - 400;
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        // setONTHEBOOKS({ IsDisplay: false, Property: { top: 0, left: 0 } });
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const [groupModal, setGroupModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const handleGroupBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setGroupModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeGroupDate = () => {
        selectedTdIndexRef.current = -1;
        setGroupModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const asOfDate = para?.asOfDate || defaultAsOfDateFromRTK || moment().format("YYYY-MM-DD");
    const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyDetailFromRTK?.propertycode || "";
    const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;

    const [activeTab, setActiveTab] = useState(1);

    const [InputPara, setInputPara] = useState(
        {
            groupname: "",
            numberofrooms: 0,
            numberofnights: 0,
            baserateoffset: 0,
            checkindate: "",
            checkoutdate: "",
            checkoutdateafteremoveoneday: "",
            checkoutmindate: "",
            proposedgrouprate: 0,
            discountshare: 0,
            totalpropertyrooms: (propertyDetailFromRTK && propertyDetailFromRTK.revenuconfig && propertyDetailFromRTK.revenuconfig[0].totalrooms) ? propertyDetailFromRTK.revenuconfig[0].totalrooms : 0,
            fbrevroomnight: 0,
            meetingroomrevroomnight: 0,
            ancillaryrevroomnight: 0,
            groupacquisitioncost: 0,
            transientacquisitioncost: 0,
            numberofroomsArray: [],
            validationRule: [
                {
                    fieldName: "groupname",
                    rule: validationRule.required,
                    message: "Group name is required",
                },
                {
                    fieldName: "numberofrooms",
                    rule: validationRule.required,
                    message: "Number of rooms is required",
                },
                {
                    fieldName: "checkindate",
                    rule: validationRule.required,
                    message: "Check-in date is required",
                },
                {
                    fieldName: "checkoutdate",
                    rule: validationRule.required,
                    message: "Check-out date is required",
                }
            ],
            errorObj: {},
            isValidate: true,
        });

    const [Calculation, setCalculation] = useState({
        GroupRoomNights: 0,
        ProposedGroupRate: 0,
        TotalGroupRoomRevenue: 0,
        FAndBRevenue: 0,
        MeetingRoomRevenue: 0,
        AncillaryRevenue: 0,
        TotalGroupRevenueGross: 0,
        DisplacedRoomNights: 0,
        AvgTransientADRforDates: 0,
        DisplacedTransientRoomRevenue: 0,
        DisplacedFBRevenue: 0, // Newly Added as per sheet
        DisplacedAncillaryTransient: 0,
        TotalDisplacedTransientRevenue: 0,
        GroupRevenueGross: 0,
        LessDisplacedTransientRevenue: 0,
        LessGroupAcquisitionCost: 0,
        PlusSavedTransientAcquisitionCost: 0,
        NETGROUPPROFITLOSS: 0,
        DiscountvsStandardPrice: 0,
        BreakevenGroupRateroomonly: 0,
        RecommendedMinRateinclancillaryoffset: 0,
        GroupProfitLoss: 0,
        Verdict: ""
    });

    const [MultiScenarioRateComparison, setMultiScenarioRateComparison] = useState({
        ProposedGroupRate: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        GroupRoomRevenue: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        FAndBMeetingAncillary: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        TotalGroupRevenue: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        DisplacedTransientRevenue: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        GroupAcquisitionCost: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        SavedTransientAcqCost: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        NetProfitLoss: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        DiscountvsStandard: {
            ScenarioA: 0,
            ScenarioB: 0,
            ScenarioC: 0,
            ScenarioD: 0
        },
        Verdict: {
            ScenarioA: "",
            ScenarioB: "",
            ScenarioC: "",
            ScenarioD: ""
        },
        BreakevenRoomOnly: 0,
        WithAncillaryOffset: 0,
        YourProposedRate: 0,
        Message: "",
    });

    const selectedEventDateRef = useRef();


    const [MultiScenarioRateComparisonHeader, setMultiScenarioRateComparisonHeader] = useState({
        ScenarioBDiscount: 10,
        ScenarioCDiscount: 20
    });

    const CalculationDetailsTotalRef = useRef({ RoomsReq: 0, StandardPrice: 0, DisplacedTransientRoomRevenue: 0, TotalDisplacedRevenue: 0, TransientAcquisitionCost: 0, GroupRoomRevenue: 0, TotalGroupRevenue : 0, GroupAcquisitionCost: 0, GroupProfitLoss: 0, DisplacedRevenue: 0, RecGroupPrice: 0, GroupProfit: 0 });

    const [showTicketModal, setShowTicketModal] = useState(false);

    function fnDoCalculation() {
        const totalRoomNights = getTotalRoomNights(InputPara.numberofroomsArray);
        const averageRoomsPerNight = InputPara.numberofnights > 0 ? Math.round(totalRoomNights / InputPara.numberofnights) : 0;

        let obj = structuredClone(Calculation);
        obj.GroupRoomNights = Math.round(totalRoomNights);
        obj.ProposedGroupRate = InputPara.proposedgrouprate;
        obj.TotalGroupRoomRevenue = Math.round(obj.GroupRoomNights * obj.ProposedGroupRate);
        obj.FAndBRevenue = Math.round(obj.GroupRoomNights * InputPara.fbrevroomnight);
        obj.MeetingRoomRevenue = Math.round(InputPara.numberofnights * InputPara.meetingroomrevroomnight);
        obj.AncillaryRevenue = Math.round(obj.GroupRoomNights * InputPara.ancillaryrevroomnight);
        obj.TotalGroupRevenueGross = Math.round(obj.TotalGroupRoomRevenue + obj.FAndBRevenue + obj.MeetingRoomRevenue + obj.AncillaryRevenue);
        obj.DisplacedRoomNights = obj.GroupRoomNights;
        obj.AvgTransientADRforDates = TransientForecastDataTotal.transientadr;
        
        // Calculate Displaced Room Revenue by summing each night's displaced revenue
        const displacedRoomRevenue = TransientForecastData.reduce((sum, item) => {
            const roomsRequested = getRoomsForStayDate(item.dates);
            return sum + (roomsRequested * item.transientadr);
        }, 0);
        obj.DisplacedTransientRoomRevenue = Math.round(displacedRoomRevenue);
        
        // // Newly Added as per sheet
        // obj.DisplacedFBRevenue = Math.round(InputPara.fbrevroomnight * InputPara.numberofnights); 
        
        // Second Updations Added as per sheet
        obj.DisplacedFBRevenue = Math.round(InputPara.fbrevroomnight * obj.GroupRoomNights); 
        
        obj.DisplacedAncillaryTransient = Math.round(obj.DisplacedRoomNights * InputPara.ancillaryrevroomnight);
        obj.TotalDisplacedTransientRevenue = Math.round(obj.DisplacedTransientRoomRevenue + obj.DisplacedAncillaryTransient + obj.DisplacedFBRevenue);   // Newly Added as per sheet
        obj.GroupRevenueGross = obj.TotalGroupRevenueGross;
        obj.LessDisplacedTransientRevenue = obj.TotalDisplacedTransientRevenue;
        obj.LessGroupAcquisitionCost = Math.round((obj.TotalGroupRevenueGross * InputPara.groupacquisitioncost) / 100);
        obj.PlusSavedTransientAcquisitionCost = Math.round((obj.TotalDisplacedTransientRevenue * InputPara.transientacquisitioncost) / 100);
        obj.NETGROUPPROFITLOSS = Math.round(obj.GroupRevenueGross - obj.LessDisplacedTransientRevenue - obj.LessGroupAcquisitionCost + obj.PlusSavedTransientAcquisitionCost);
        obj.DiscountvsStandardPrice = ((1 - (obj.ProposedGroupRate / obj.AvgTransientADRforDates)) * 100).toFixed(1);
        obj.BreakevenGroupRateroomonly = Math.round(obj.AvgTransientADRforDates * (1 - (InputPara.transientacquisitioncost / 100)) / (1 - (InputPara.groupacquisitioncost / 100)));
        obj.RecommendedMinRateinclancillaryoffset = Math.round(obj.BreakevenGroupRateroomonly - (InputPara.fbrevroomnight + (averageRoomsPerNight > 0 ? (InputPara.meetingroomrevroomnight / averageRoomsPerNight) : 0)));
        obj.GroupProfitLoss = obj.NETGROUPPROFITLOSS;
        obj.Verdict = obj.NETGROUPPROFITLOSS > 0 ? "ACCEPT" : "REJECT";

        // Newly Added as per sheet
        // Previous
        // CalculationDetailsTotalRef.current = { RoomsReq: 0, StandardPrice: 0, DisplacedRevenue: 0, RecGroupPrice: 0, GroupProfit: 0 }; 
        // New
        CalculationDetailsTotalRef.current = { RoomsReq: 0, StandardPrice: 0,DisplacedTransientRoomRevenue: 0, DisplacedRevenue: 0, TransientAcquisitionCost: 0,TotalDisplacedRevenue: 0, GroupRoomRevenue: 0, TotalGroupRevenue: 0, GroupAcquisitionCost: 0, GroupProfitLoss: 0, RecGroupPrice: 0, GroupProfit: 0 };

        setCalculation(obj);

        let objMSRC = structuredClone(MultiScenarioRateComparison);
        const scenarioDProposedRate = Math.round(InputPara.proposedgrouprate * (1 - (InputPara.discountshare / 100)));

        objMSRC.ProposedGroupRate.ScenarioA = Math.round(TransientForecastDataTotal.transientadr);
        objMSRC.ProposedGroupRate.ScenarioD = scenarioDProposedRate;
        objMSRC.ProposedGroupRate.ScenarioB = Math.round(scenarioDProposedRate * (1 - (MultiScenarioRateComparisonHeader.ScenarioBDiscount / 100)));
        objMSRC.ProposedGroupRate.ScenarioC = Math.round(scenarioDProposedRate * (1 - (MultiScenarioRateComparisonHeader.ScenarioCDiscount / 100)));
        

        objMSRC.GroupRoomRevenue.ScenarioA = Math.round(objMSRC.ProposedGroupRate.ScenarioA * obj.GroupRoomNights);
        objMSRC.GroupRoomRevenue.ScenarioB = Math.round(objMSRC.ProposedGroupRate.ScenarioB * obj.GroupRoomNights);
        objMSRC.GroupRoomRevenue.ScenarioC = Math.round(objMSRC.ProposedGroupRate.ScenarioC * obj.GroupRoomNights);
        objMSRC.GroupRoomRevenue.ScenarioD = Math.round(objMSRC.ProposedGroupRate.ScenarioD * obj.GroupRoomNights);

        objMSRC.FAndBMeetingAncillary.ScenarioA = Math.round(obj.FAndBRevenue + obj.MeetingRoomRevenue + obj.AncillaryRevenue);
        objMSRC.FAndBMeetingAncillary.ScenarioB = Math.round(obj.FAndBRevenue + obj.MeetingRoomRevenue + obj.AncillaryRevenue);
        objMSRC.FAndBMeetingAncillary.ScenarioC = Math.round(obj.FAndBRevenue + obj.MeetingRoomRevenue + obj.AncillaryRevenue);
        objMSRC.FAndBMeetingAncillary.ScenarioD = Math.round(obj.FAndBRevenue + obj.MeetingRoomRevenue + obj.AncillaryRevenue);


        objMSRC.TotalGroupRevenue.ScenarioA = Math.round(objMSRC.GroupRoomRevenue.ScenarioA + objMSRC.FAndBMeetingAncillary.ScenarioA);
        objMSRC.TotalGroupRevenue.ScenarioB = Math.round(objMSRC.GroupRoomRevenue.ScenarioB + objMSRC.FAndBMeetingAncillary.ScenarioB);
        objMSRC.TotalGroupRevenue.ScenarioC = Math.round(objMSRC.GroupRoomRevenue.ScenarioC + objMSRC.FAndBMeetingAncillary.ScenarioC);
        objMSRC.TotalGroupRevenue.ScenarioD = Math.round(objMSRC.GroupRoomRevenue.ScenarioD + objMSRC.FAndBMeetingAncillary.ScenarioD);

        // Calculate Displaced Transient Revenue by summing each night's displaced revenue (same for all scenarios)
        const displacedRoomRevenueScenario = TransientForecastData.reduce((sum, item) => {
            const roomsRequested = getRoomsForStayDate(item.dates);
            return sum + (roomsRequested * item.transientadr);
        }, 0);
        const displacedAncillaryRevenueScenario = Math.round(obj.DisplacedRoomNights * InputPara.ancillaryrevroomnight);
        const displacedTransientRevenueTotal = Math.round(displacedRoomRevenueScenario + displacedAncillaryRevenueScenario + obj.DisplacedFBRevenue);

        objMSRC.DisplacedTransientRevenue.ScenarioA = displacedTransientRevenueTotal;
        objMSRC.DisplacedTransientRevenue.ScenarioB = displacedTransientRevenueTotal;
        objMSRC.DisplacedTransientRevenue.ScenarioC = displacedTransientRevenueTotal;
        objMSRC.DisplacedTransientRevenue.ScenarioD = displacedTransientRevenueTotal;

        objMSRC.GroupAcquisitionCost.ScenarioA = Math.round((objMSRC.TotalGroupRevenue.ScenarioA * InputPara.groupacquisitioncost) / 100);
        objMSRC.GroupAcquisitionCost.ScenarioB = Math.round((objMSRC.TotalGroupRevenue.ScenarioB * InputPara.groupacquisitioncost) / 100);
        objMSRC.GroupAcquisitionCost.ScenarioC = Math.round((objMSRC.TotalGroupRevenue.ScenarioC * InputPara.groupacquisitioncost) / 100);
        objMSRC.GroupAcquisitionCost.ScenarioD = Math.round((objMSRC.TotalGroupRevenue.ScenarioD * InputPara.groupacquisitioncost) / 100);


        objMSRC.SavedTransientAcqCost.ScenarioA = Math.round((objMSRC.DisplacedTransientRevenue.ScenarioA * InputPara.transientacquisitioncost) / 100);
        objMSRC.SavedTransientAcqCost.ScenarioB = Math.round((objMSRC.DisplacedTransientRevenue.ScenarioB * InputPara.transientacquisitioncost) / 100);
        objMSRC.SavedTransientAcqCost.ScenarioC = Math.round((objMSRC.DisplacedTransientRevenue.ScenarioC * InputPara.transientacquisitioncost) / 100);
        objMSRC.SavedTransientAcqCost.ScenarioD = Math.round((objMSRC.DisplacedTransientRevenue.ScenarioD * InputPara.transientacquisitioncost) / 100);


        objMSRC.NetProfitLoss.ScenarioA = Math.round(objMSRC.TotalGroupRevenue.ScenarioA - objMSRC.DisplacedTransientRevenue.ScenarioA - objMSRC.GroupAcquisitionCost.ScenarioA + objMSRC.SavedTransientAcqCost.ScenarioA);
        objMSRC.NetProfitLoss.ScenarioB = Math.round(objMSRC.TotalGroupRevenue.ScenarioB - objMSRC.DisplacedTransientRevenue.ScenarioB - objMSRC.GroupAcquisitionCost.ScenarioB + objMSRC.SavedTransientAcqCost.ScenarioB);
        objMSRC.NetProfitLoss.ScenarioC = Math.round(objMSRC.TotalGroupRevenue.ScenarioC - objMSRC.DisplacedTransientRevenue.ScenarioC - objMSRC.GroupAcquisitionCost.ScenarioC + objMSRC.SavedTransientAcqCost.ScenarioC);
        objMSRC.NetProfitLoss.ScenarioD = Math.round(objMSRC.TotalGroupRevenue.ScenarioD - objMSRC.DisplacedTransientRevenue.ScenarioD - objMSRC.GroupAcquisitionCost.ScenarioD + objMSRC.SavedTransientAcqCost.ScenarioD);


        objMSRC.DiscountvsStandard.ScenarioA = ((1 - (objMSRC.ProposedGroupRate.ScenarioA / TransientForecastDataTotal.transientadr)) * 100).toFixed(1);
        objMSRC.DiscountvsStandard.ScenarioB = ((1 - (objMSRC.ProposedGroupRate.ScenarioB / TransientForecastDataTotal.transientadr)) * 100).toFixed(1);
        objMSRC.DiscountvsStandard.ScenarioC = ((1 - (objMSRC.ProposedGroupRate.ScenarioC / TransientForecastDataTotal.transientadr)) * 100).toFixed(1);
        objMSRC.DiscountvsStandard.ScenarioD = ((1 - (objMSRC.ProposedGroupRate.ScenarioD / TransientForecastDataTotal.transientadr)) * 100).toFixed(1);


        objMSRC.Verdict.ScenarioA = objMSRC.NetProfitLoss.ScenarioA > 0 ? "ACCEPT" : "REJECT";
        objMSRC.Verdict.ScenarioB = objMSRC.NetProfitLoss.ScenarioB > 0 ? "ACCEPT" : "REJECT";
        objMSRC.Verdict.ScenarioC = objMSRC.NetProfitLoss.ScenarioC > 0 ? "ACCEPT" : "REJECT";
        objMSRC.Verdict.ScenarioD = objMSRC.NetProfitLoss.ScenarioD > 0 ? "ACCEPT" : "REJECT";


        objMSRC.BreakevenRoomOnly = Math.round(Calculation.AvgTransientADRforDates * ((1 - (InputPara.transientacquisitioncost / 100))) / ((1 - (InputPara.groupacquisitioncost / 100))));
        objMSRC.WithAncillaryOffset = Math.round(objMSRC.BreakevenRoomOnly - (InputPara.fbrevroomnight + (averageRoomsPerNight > 0 ? (InputPara.meetingroomrevroomnight / averageRoomsPerNight) : 0)));
        // objMSRC.YourProposedRate = InputPara.proposedgrouprate;
        objMSRC.YourProposedRate = objMSRC.ProposedGroupRate.ScenarioD;
        objMSRC.Message = "";

        setMultiScenarioRateComparison(objMSRC);


    }

    function fnSetActiveTab(tabno) {
        //document.documentElement.scrollTo({
        //    top: 0,
        //    behavior: "smooth"
        //});


        if (tabno > 1) {
            fnDoCalculation();
        }

        setActiveTab(tabno)
    }

    const [DataLoading, setDataLoading] = useState(false);
    const [showTabTwoContent, setShowTabTwoContent] = useState(false);

    const [TransientForecastData, setTransientForecastData] = useState([]);

    const [TransientForecastDataTotal, setTransientForecastDataTotal] = useState({
        dates: "",
        staydate: "",
        dow: "",
        fcstocc: 0,
        transientadr: 0,
        compsetavg: 0,
        demandscore: 0,
        exptransientrooms: 0,
        exptransientrev: 0,
        roomsavailable: 0,
        OOO: 0,
        RoomAvailable: 0,
        LeftToSell: 0,
        avgleadtime: 0,
        OnTheBook: 0,
        TotalOCCPercentage: 0,
        ADR: 0,
        REV: 0,
        RevPAR: 0,
        OTB: 0,
        Block: 0,
        ForecastADR: 0,
        ForecastRMS: 0,
        ForecastREV: 0,
        ForecastOccperc: 0
    });
    // const buildDateWiseRooms = (checkInDate, checkOutDate, existingRooms = []) => {
    const buildDateWiseRooms = (checkInDate, checkOutDate, existingRooms = [], defaultRoomCount = 0) => {
        if (!checkInDate || !checkOutDate) {
            return [];
        }

        const existingRoomsMap = new Map(
            (existingRooms || []).map((item) => [item.dateKey, item.rooms || 0])
        );

        const stayDates = [];
        const currentDate = new Date(commonService.getDateInDBFormat(checkInDate) + " 00:00:00");
        const endDate = new Date(commonService.getDateInDBFormat(checkOutDate) + " 00:00:00");

        while (currentDate < endDate) {
            const dateKey = moment(currentDate).format("YYYY-MM-DD");
            stayDates.push({
                dateKey,
                date: new Date(currentDate),
                // Newly added dates (when date range changes) will have 0 rooms
                rooms: existingRoomsMap.has(dateKey) ? existingRoomsMap.get(dateKey) : 0,
            });
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return stayDates;
    };

    const handleDateWiseRoomChange = (dateKey, value) => {
        const rooms = value ? parseInt(value) || 0 : "";
        const updatedRoomsArray = InputPara.numberofroomsArray.map((item) =>
            item.dateKey === dateKey ? { ...item, rooms } : item
        );

        // Only update the specific room, don't modify numberofrooms
        setInputPara({
            ...InputPara,
            numberofroomsArray: updatedRoomsArray,
        });
    };

    const getTotalRoomNights = (roomsArray = []) =>
        (roomsArray || []).reduce((sum, item) => sum + (parseInt(item.rooms) || 0), 0);

    const getRoomsForStayDate = (dateKey) => {
        const matchedDate = (InputPara.numberofroomsArray || []).find((item) => item.dateKey === dateKey);
        return parseInt(matchedDate?.rooms) || 0;
    };

    useEffect(() => {
    if (api === 0) return;
    if(propertyDetailFromRTK && propertyDetailFromRTK.revenuconfig && propertyDetailFromRTK.revenuconfig[0].totalrooms){
        setInputPara((prev) => {
            return {
                ...prev,
                totalpropertyrooms: (propertyDetailFromRTK.revenuconfig[0].totalrooms) ? propertyDetailFromRTK.revenuconfig[0].totalrooms : 0
            };
        });
    }
    }, [propertyDetailFromRTK]);

    useEffect(() => {
    if (api === 0) return;
        fnDoCalculation();
    }, [InputPara, MultiScenarioRateComparisonHeader, TransientForecastDataTotal, TransientForecastData]);

    const getEventList = async () => {
        if (api === 0) return;
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyId),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                } catch (err) { }
            });
            eventListRef.current = eventListArr;
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
        }
    };

    const sevenMaxDateRef = useRef();

    const eventListPropsRef = useRef();

    if (asOfDate) {
        let sevenDate = new Date(new Date(asOfDate));
        sevenMaxDateRef.current = sevenDate.setDate(sevenDate.getDate() - 7);
    }

    const APICalling = async () => {
        if (api === 0) return;
        if (asOfDate && propertyCode) {



            let validation = checkValidation(InputPara);

            if (!validation.isValidate) {
                setInputPara(validation);
                return;
            }

            setDataLoading(true);

            let APIDataList = [];

            // Single unified API call for all forecast and OTB data
            let ForecastAPICall = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.DISPLACEMENT.DISPLACEMENT_TRANSIENT_OTB_FORECAST,
                    body: {
                        asofdate: commonService.getDateInDBFormat(asOfDate),
                        startdate: commonService.getDateInDBFormat(InputPara.checkindate),
                        enddate: commonService.getDateInDBFormat(InputPara.checkoutdateafteremoveoneday),
                        propertycode: propertyCode,
                        forcasttype: "nova",
                        propertyid: propertyId,
                    },
                },
                false
            );

            let ForecastResponse = apiResponse(false, ForecastAPICall);

            if (ForecastResponse?.isValidate) {
                ForecastResponse?.data?.data.map((item) => {
                    const otbAdr = item.OTB_ADR ? Math.round(item.OTB_ADR) : 0;
                    const otbRms = item.OTB_RMS ? Math.round(item.OTB_RMS) : 0;
                    const tmp_exptransientrev = otbAdr * otbRms;

                    const forecastAdr = item.Forecast_ADR ? Math.round(item.Forecast_ADR) : 0;
                    const forecastRms = item.Forecast_RMS ? Math.round(item.Forecast_RMS) : 0;
                    const forecastRev = item.Forecast_REV ? Math.round(item.Forecast_REV) : 0;
                    const forecastOccperc = item.Forecast_Occperc ? Math.round(item.Forecast_Occperc) : 0;

                    APIDataList.push({
                        dates: commonService.getDateInDBFormat(item.Dates),
                        staydate: commonService.getDateInFormat(commonService.convertDateInTimezone(item.Dates)),
                        dow: moment(commonService.convertDateInTimezone(item.Dates), "l").format("ddd"),
                        fcstocc: item.Forecast_Occperc ? Math.round(item.Forecast_Occperc) : 0,
                        transientadr: forecastAdr,
                        compsetavg: item.Avg_CompSet ? Math.round(item.Avg_CompSet) : 0,
                        demandscore: item.TotalDemandScore ? Math.round(item.TotalDemandScore) : 0,
                        exptransientrooms: forecastRms,
                        exptransientrev: forecastAdr * forecastRms,
                        roomsavailable: item.Inventory ? Math.round(item.Inventory) : 0,

                        OOO: item.OutOfOrder ? Math.round(item.OutOfOrder) : 0,
                        RoomAvailable: item.Inventory ? Math.round(item.Inventory) : 0,
                        LeftToSell: item.LeftToSell ? Math.round(item.LeftToSell) : 0,
                        avgleadtime: item.AvgLeadtime ? Math.round(item.AvgLeadtime) : 0,
                        OnTheBook: item.OTB_RMS ? Math.round(item.OTB_RMS) : 0,
                        TotalOCCPercentage: item.OTB_Occperc ? Math.round(item.OTB_Occperc) : 0,
                        ADR: item.OTB_ADR ? Math.round(item.OTB_ADR) : 0,
                        REV: item.OTB_REV ? Math.round(item.OTB_REV) : 0,
                        RevPAR: item.OTB_RevPAR ? Math.round(item.OTB_RevPAR) : 0,
                        OTB: item.GroupOTB ? Math.round(item.GroupOTB) : 0,
                        Block: item.GroupBlock ? Math.round(item.GroupBlock) : 0,

                        // Forecast fields from API
                        ForecastADR: forecastAdr,
                        ForecastRMS: forecastRms,
                        ForecastREV: forecastRev,
                        ForecastOccperc: item.Forecast_Occperc ? Math.round(item.Forecast_Occperc) : 0
                    })
                });
            }

            await getEventList();

            let demandscoreTotal = APIDataList.reduce((sum, item) => sum + (item.demandscore ? Math.round(item.demandscore) : 0), 0);

            // Calculate OTB totals
            const totalRevenue = APIDataList.reduce((sum, item) => sum + ((item.exptransientrooms || 0) * (item.transientadr || 0)), 0);
            const totalRooms = APIDataList.reduce((sum, item) => sum + (item.exptransientrooms || 0), 0);
            const avgADR = totalRooms > 0 ? Math.round(totalRevenue / totalRooms) : 0;

            // Calculate Forecast totals
            const totalForecastRevenue = APIDataList.reduce((sum, item) => sum + (item.ForecastREV || 0), 0);
            const totalForecastRooms = APIDataList.reduce((sum, item) => sum + (item.ForecastRMS || 0), 0);
            const avgForecastADR = totalForecastRooms > 0 ? Math.round(totalForecastRevenue / totalForecastRooms) : 0;
            const avgForecastOccperc = APIDataList.length > 0 ? Math.round(APIDataList.reduce((sum, item) => sum + (item.ForecastOccperc || 0), 0) / APIDataList.length) : 0;

            setTransientForecastDataTotal(
                {
                    dates: "",
                    staydate: "",
                    dow: "",
                    fcstocc: 0,
                    transientadr: avgADR,
                    compsetavg: 0,
                    demandscore: Math.round(demandscoreTotal > 0 ? (demandscoreTotal / APIDataList.length).toFixed(2) : 0),
                    exptransientrooms: totalRooms,
                    exptransientrev: Math.round(totalRevenue),
                    roomsavailable: 0,

                    OOO: Math.round(APIDataList.reduce((sum, item) => sum + (item.OOO || 0), 0)),
                    RoomAvailable: Math.round(APIDataList.reduce((sum, item) => sum + (item.RoomAvailable || 0), 0)),
                    LeftToSell: Math.round(APIDataList.reduce((sum, item) => sum + (item.LeftToSell || 0), 0)),
                    avgleadtime: Math.round(APIDataList.reduce((sum, item) => sum + (item.avgleadtime || 0), 0)),
                    OnTheBook: Math.round(APIDataList.reduce((sum, item) => sum + (item.OnTheBook || 0), 0)),
                    TotalOCCPercentage: Math.round((Math.round(APIDataList.reduce((sum, item) => sum + (item.OnTheBook || 0), 0)) / Math.round(APIDataList.reduce((sum, item) => sum + (item.RoomAvailable || 0), 0))) * 100),
                    REV: Math.round(APIDataList.reduce((sum, item) => sum + (item.REV || 0), 0)),
                    ADR: Math.round(APIDataList.reduce((sum, item) => sum + (item.REV || 0), 0)) / Math.round(APIDataList.reduce((sum, item) => sum + (item.OnTheBook || 0), 0)),

                    RevPAR: Math.round(APIDataList.reduce((sum, item) => sum + (item.RevPAR || 0), 0)) / APIDataList.length,

                    OTB: Math.round(APIDataList.reduce((sum, item) => sum + (item.OTB || 0), 0)),
                    Block: Math.round(APIDataList.reduce((sum, item) => sum + (item.Block || 0), 0)),

                    // Forecast totals
                    ForecastADR: avgForecastADR,
                    ForecastRMS: totalForecastRooms,
                    ForecastREV: Math.round(totalForecastRevenue),
                    ForecastOccperc: avgForecastOccperc
                }
            )
            setInputPara({
                ...InputPara,
                numberofnights: APIDataList?.length
            });
            setTransientForecastData(APIDataList);
            setDataLoading(false);
            setShowTabTwoContent(true)
            // fnSetActiveTab(2);
        }
    }

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const handleChange = (index, field, value) => {
        const updatedData = [...TransientForecastData];
        let numValue = parseFloat(value) || 0;
        updatedData[index][field] = numValue;
        
        // Calculate OTB revenue from rooms * ADR
        const adr = updatedData[index].transientadr || 0;
        const rooms = updatedData[index].exptransientrooms || 0;
        updatedData[index].exptransientrev = adr * rooms;

        // Calculate Forecast revenue from forecast rooms * forecast ADR
        const forecastAdr = updatedData[index].ForecastADR || 0;
        const forecastRooms = updatedData[index].ForecastRMS || 0;
        updatedData[index].ForecastREV = forecastAdr * forecastRooms;

        let demandscoreTotal = updatedData.reduce((sum, item) => sum + (item.demandscore ? Math.round(item.demandscore) : 0), 0);
        
        // Calculate OTB totals
        const totalRevenue = updatedData.reduce((sum, item) => sum + ((item.exptransientrooms || 0) * (item.transientadr || 0)), 0);
        const totalRooms = updatedData.reduce((sum, item) => sum + (item.exptransientrooms || 0), 0);
        const avgADR = totalRooms > 0 ? Math.round(totalRevenue / totalRooms) : 0;

        // Calculate Forecast totals
        const totalForecastRevenue = updatedData.reduce((sum, item) => sum + (item.ForecastREV || 0), 0);
        const totalForecastRooms = updatedData.reduce((sum, item) => sum + (item.ForecastRMS || 0), 0);
        const avgForecastADR = totalForecastRooms > 0 ? Math.round(totalForecastRevenue / totalForecastRooms) : 0;
        const avgForecastOccperc = updatedData.length > 0 ? Math.round(updatedData.reduce((sum, item) => sum + (item.ForecastOccperc || 0), 0) / updatedData.length) : 0;
        
        setTransientForecastData(updatedData);
        setTransientForecastDataTotal(
            {
                dates: "",
                staydate: "",
                dow: "",
                fcstocc: 0,
                transientadr: avgADR,
                compsetavg: 0,
                demandscore: demandscoreTotal > 0 ? (demandscoreTotal / updatedData.length).toFixed(2) : 0,
                exptransientrooms: totalRooms,
                exptransientrev: Math.round(totalRevenue),
                roomsavailable: 0,

                OOO: Math.round(updatedData.reduce((sum, item) => sum + (item.OOO || 0), 0)),
                RoomAvailable: Math.round(updatedData.reduce((sum, item) => sum + (item.RoomAvailable || 0), 0)),
                LeftToSell: Math.round(updatedData.reduce((sum, item) => sum + (item.LeftToSell || 0), 0)),
                avgleadtime: Math.round(updatedData.reduce((sum, item) => sum + (item.avgleadtime || 0), 0)),
                OnTheBook: Math.round(updatedData.reduce((sum, item) => sum + (item.OnTheBook || 0), 0)),
                TotalOCCPercentage: Math.round((Math.round(updatedData.reduce((sum, item) => sum + (item.OnTheBook || 0), 0)) / Math.round(updatedData.reduce((sum, item) => sum + (item.RoomAvailable || 0), 0))) * 100),
                REV: Math.round(updatedData.reduce((sum, item) => sum + (item.REV || 0), 0)),
                ADR: Math.round(updatedData.reduce((sum, item) => sum + (item.REV || 0), 0)) / Math.round(updatedData.reduce((sum, item) => sum + (item.OnTheBook || 0), 0)),
                RevPAR: Math.round(updatedData.reduce((sum, item) => sum + (item.RevPAR || 0), 0)) / updatedData.length,
                OTB: Math.round(updatedData.reduce((sum, item) => sum + (item.OTB || 0), 0)),
                Block: Math.round(updatedData.reduce((sum, item) => sum + (item.Block || 0), 0)),

                // Forecast totals
                ForecastADR: avgForecastADR,
                ForecastRMS: totalForecastRooms,
                ForecastREV: Math.round(totalForecastRevenue),
                ForecastOccperc: avgForecastOccperc
            }
        )
    };

    function printDiv() {

        const panel = document.getElementById("panel4");
        const root = document.getElementById("root");

        // Hide main root
        root.style.display = "none";

        // Create new div
        const printDiv = document.createElement("div");
        printDiv.id = "printdiv";
        printDiv.innerHTML = panel.innerHTML;

        document.body.appendChild(printDiv);

        // Print
        window.print();

        setTimeout(() => {
            document.body.removeChild(printDiv);
            root.style.display = "block";
        }, 100);
    }

    commonService.setBackColorPerByTDValueInPercentage(
        "Green",
        "Red",
        `#tblTransientForecastStayDates .TotalOCCPercentage`
    );

    commonService.setBackColorPerByTDValueInPercentage(
        "#FFDEA1",
        "Red",
        `#tblTransientForecastStayDates .perbackground-GroupOTB`
    );

    return (
        <div className="displacementcalculator">
            {propertyCode ? (
                <Container fluid>
                    <Row>
                        <Col xl={12}>
                            <div className="ProspectDashboardTitleWraper  d-flex justify-content-between align-items-center">
                                <h2>
                                    Dashboard-{" "}
                                    <span className="tab-title-main">
                                        Revenue Management - Tools - Displacement Calculator
                                    </span>
                                    <div id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "div-onclick", "")} className="cursorPointer heading-menu-btns btn-email-all btn btn-primary" style={{ position: "absolute", right: "50px", top: "5px", width: "auto" }}
                                        onClick={() => {
                                            if (api === 0) return;
                                            setWidgetModal(true);
                                        }}>
                                        <img src={infoIcon} alt="graphIcon" />
                                    </div>
                                </h2>
                            </div>
                        </Col>
                        <Col xl={12}>
                            <nav className="stepper-bar">
                                <div className={`step ${activeTab === 1 ? "active" : ""} ${activeTab > 1 ? "completed" : ""}`} id="step1Indicator" onClick={(e) => fnSetActiveTab(1)}>
                                    <div className="step-num">1</div>
                                    <span className="step-label">Group Details</span>
                                </div>
                                {/* <div className={`step-connector ${activeTab > 1 ? "filled" : ""}`} id="connector1"></div> */}
                                {/* <div className={`step ${activeTab === 2 ? "active" : ""} ${activeTab > 2 ? "completed" : ""}`} id="step1Indicator" onClick={(e) => TransientForecastData && TransientForecastData.length > 0 && fnSetActiveTab(2)}>
                                    <div className="step-num">2</div>
                                    <span className="step-label">Transient Forecast</span>
                                </div> */}
                                <div className={`step-connector ${activeTab > 2 ? "filled" : ""}`} id="connector1"></div>
                                <div className={`step ${activeTab === 3 ? "active" : ""} ${activeTab > 3 ? "completed" : ""}`} id="step2Indicator" onClick={(e) => TransientForecastData && TransientForecastData.length > 0 && fnSetActiveTab(3)}>
                                    {/* <div className="step-num">3</div> */}
                                    <div className="step-num">2</div>
                                    <span className="step-label">Displacement Results</span>
                                </div>
                                <div className={`step-connector ${activeTab > 3 ? "filled" : ""}`} id="connector2"></div>
                                <div className={`step ${activeTab === 4 ? "active" : ""}`} id="step3Indicator" onClick={(e) => TransientForecastData && TransientForecastData.length > 0 && fnSetActiveTab(4)}>
                                    {/* <div className="step-num">4</div> */}
                                    <div className="step-num">3</div>
                                    <span className="step-label">Scenario Comparison</span>
                                </div>
                            </nav>
                            <div className="stepper-container">
                                {
                                    activeTab === 1 &&
                                    <section className="panel" id="panel1">
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="card-title"> Group Details</div>
                                                <span >Calculate a new quote</span>
                                            </div>
                                            <div className="card-body">
                                                <div className="form-grid three-col">
                                                    <div className="form-group">
                                                        <label className="form-label">Group Name *</label>
                                                        <input className="form-input" id="groupName"
                                                            value={InputPara.groupname}
                                                            onChange={(e) => {
                                                                setInputPara({
                                                                    ...InputPara,
                                                                    groupname: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                        {InputPara?.errorObj?.groupname && (
                                                            <small className="text-danger">
                                                                {InputPara?.errorObj?.groupname}
                                                            </small>
                                                        )}
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Proposed Group Rate</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">$</span>
                                                            <input className="form-input" id="groupRate" type="number"
                                                                value={InputPara.proposedgrouprate}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        proposedgrouprate: parseInt(e.target.value),
                                                                    });
                                                                }}

                                                                min="0" />
                                                        </div>
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="form-label">Base Rate Offset</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">$</span>
                                                            <input className="form-input" id="rateOffset" type="number"
                                                                value={InputPara.baserateoffset}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        baserateoffset: parseInt(e.target.value),
                                                                    });
                                                                }}
                                                                min="0" />
                                                        </div>
                                                        <span className="form-hint">Added to recommended rate</span>
                                                    </div>


                                                    {/* <div className="form-group">
                                                        <label className="form-label">Discount Share</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">%</span>
                                                            <input className="form-input" id="discountShare" type="number"
                                                                value={InputPara.discountshare}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        discountshare: e.target.value ? parseInt(e.target.value) || 0 : "",
                                                                    });
                                                                }}

                                                                min="0" max="100" />
                                                        </div>
                                                        <span className="form-hint">Percentage of discount absorbed</span>
                                                    </div> */}

                                                    <div className="form-group">
                                                        <label className="form-label">Check-In Date *</label>
                                                        <DatePicker id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "check-in-date", "")}
                                                            portalId="datepicker-root"
                                                            className="form-input"
                                                            minDate={new Date()}
                                                            selected={InputPara.checkindate ? InputPara.checkindate : ""}
                                                            onChange={(date) => {
                                                                let numberofnights = 0;

                                                                if (date && InputPara.checkoutdate) {
                                                                    numberofnights = commonService.getDateBetweenTwoDates(new Date(commonService.getDateInDBFormat(date)), new Date(commonService.getDateInDBFormat(InputPara.checkoutdate))).length - 1
                                                                }


                                                                let baseDate = date
                                                                    ? new Date(commonService.getDateInDBFormat(date) + " 00:00:00")
                                                                    : new Date();

                                                                baseDate.setDate(baseDate.getDate() + 1);
                                                                // Build rooms array with all rooms set to 0
                                                                const updatedRoomsArray = buildDateWiseRooms(date, InputPara.checkoutdate, []);

                                                                setInputPara({
                                                                    ...InputPara,
                                                                    checkindate: date,
                                                                    checkoutdate: null,
                                                                    checkoutmindate: baseDate,
                                                                    numberofnights: parseInt(numberofnights),
                                                                    numberofroomsArray: updatedRoomsArray,
                                                                    numberofrooms: 0,
                                                                });
                                                                setShowTabTwoContent(false)
                                                            }}
                                                        />
                                                        {InputPara?.errorObj?.checkindate && (
                                                            <small className="text-danger">
                                                                {InputPara?.errorObj?.checkindate}
                                                            </small>
                                                        )}
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Check-Out Date *</label>
                                                        <DatePicker id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "check-out-date", "")}
                                                            portalId="datepicker-root"
                                                            className="form-input"
                                                            minDate={InputPara.checkoutmindate ? new Date(commonService.getDateInDBFormat(InputPara.checkoutmindate)) : new Date()}
                                                            selected={InputPara.checkoutdate ? InputPara.checkoutdate : ""}
                                                            onChange={(date) => {

                                                                let numberofnights = 0;

                                                                if (InputPara.checkindate && date) {
                                                                    numberofnights = commonService.getDateBetweenTwoDates(new Date(commonService.getDateInDBFormat(InputPara.checkindate)), new Date(commonService.getDateInDBFormat(date))).length - 1;
                                                                }

                                                                let baseDate = date
                                                                    ? new Date(commonService.getDateInDBFormat(date) + " 00:00:00")
                                                                    : new Date();

                                                                baseDate.setDate(baseDate.getDate() - 1);
                                                                // Build rooms array with all rooms set to 0
                                                                const updatedRoomsArray = buildDateWiseRooms(InputPara.checkindate, date, []);

                                                                setInputPara({
                                                                    ...InputPara,
                                                                    checkoutdate: date,
                                                                    checkoutdateafteremoveoneday: baseDate,
                                                                    numberofnights: parseInt(numberofnights),
                                                                    numberofroomsArray: updatedRoomsArray,
                                                                    numberofrooms: 0,
                                                                });
                                                                setShowTabTwoContent(false)
                                                            }}
                                                        />
                                                        {InputPara?.errorObj?.checkoutdate && (
                                                            <small className="text-danger">
                                                                {InputPara?.errorObj?.checkoutdate}
                                                            </small>
                                                        )}

                                                    </div>
                                                      <div className="form-group">
                                                        <label className="form-label">Number of Rooms *</label>
                                                        <div className="input-wrapper">
                                                            <input className="form-input" id="numRooms" type="number"
                                                                disabled={false}
                                                                value={InputPara.numberofrooms}
                                                                onChange={(e) => {
                                                                    const newValue = parseInt(e.target.value) || 0;
                                                                    
                                                                    // When numberofrooms changes, assign it to all rooms in the array
                                                                    const updatedArray = InputPara.numberofroomsArray.map((item) => ({
                                                                        ...item,
                                                                        rooms: newValue
                                                                    }));
                                                                    
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        numberofrooms: newValue,
                                                                        numberofroomsArray: updatedArray,
                                                                    });
                                                                }}
                                                                min="1" max="500" />
                                                            {
                                                                InputPara.checkindate && InputPara.checkoutdate &&
                                                                <button id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "distribute-rooms-across-dates", "")} 
                                                                    className="grid-toggle-btn-icon pe-0"
                                                                    onClick={() => {
                                                                        setShowRoomDistributionModal(true);
                                                                    }}
                                                                    type="button"
                                                                    title="Distribute rooms across dates"
                                                                >
                                                                    <img src={divide} alt="Distribute rooms" />
                                                                </button>
                                                            }
                                                        </div>

                                                        {InputPara?.errorObj?.numberofrooms && (
                                                            <small className="text-danger">
                                                                {InputPara?.errorObj?.numberofrooms}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="card-header">
                                                <div className="card-title"> Property Assumptions</div>
                                                <span>{propertyDetailFromRTK?.propertyname} {propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms} Rooms</span>
                                            </div>
                                            <div className="card-body">
                                                <div className="form-grid three-col">
                                                    <div className="form-group">
                                                        <label className="form-label">Total Property Rooms</label>
                                                        <input className="form-input" id="totalRooms" type="number"
                                                            value={InputPara.totalpropertyrooms}
                                                            onChange={(e) => {
                                                                setInputPara({
                                                                    ...InputPara,
                                                                    totalpropertyrooms: parseInt(e.target.value),
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">F&amp;B Rev / Room Night</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">$</span>
                                                            <input className="form-input" id="fnbRate" type="number"

                                                                value={InputPara.fbrevroomnight}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        fbrevroomnight: parseInt(e.target.value),
                                                                    });
                                                                }}

                                                                min="0" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Meeting Room Rev / Night</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">$</span>
                                                            <input className="form-input" id="meetingRate" type="number"
                                                                value={InputPara.meetingroomrevroomnight}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        meetingroomrevroomnight: parseInt(e.target.value),
                                                                    });
                                                                }}
                                                                min="0" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Ancillary Rev / Room Night</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">$</span>
                                                            <input className="form-input" id="ancillaryRate" type="number"

                                                                value={InputPara.ancillaryrevroomnight}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        ancillaryrevroomnight: parseInt(e.target.value),
                                                                    });
                                                                }}

                                                                min="0" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Group Acquisition Cost</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">%</span>
                                                            <input className="form-input" id="groupAcqCost" type="number"
                                                                value={InputPara.groupacquisitioncost}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        groupacquisitioncost: parseInt(e.target.value),
                                                                    });
                                                                }}
                                                                min="0" max="100" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Transient Acquisition Cost</label>
                                                        <div className="input-prefix">
                                                            <span className="prefix">%</span>
                                                            <input className="form-input" id="transientAcqCost" type="number"

                                                                value={InputPara.transientacquisitioncost}
                                                                onChange={(e) => {
                                                                    setInputPara({
                                                                        ...InputPara,
                                                                        transientacquisitioncost: parseInt(e.target.value),
                                                                    });
                                                                }}

                                                                min="0" max="100" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Tab 2 Content */}
                                        {
                                         showTabTwoContent &&
                                         <section className="panel" id="panel2">
                                             <>
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <div className="card-title"> Transient Forecast (Stay Dates)</div>
                                                            <span className="confidence medium"><span className="confidence-dot"></span> From Forecast Engine</span>
                                                        </div>
                                                        <div className="card-body p-0">
                                                            <div className="ViewPropertySetupTable">
                                                                <div className="stripped__table">
                                                                    <Table responsive id="tblTransientForecastStayDates">
                                                                        <thead>

                                                                            <tr>
                                                                                <th className="width175"></th>

                                                                                <th colSpan="6" className="text-center border-right">TRANSIENT CURRENT YEAR</th>

                                                                                <th colSpan="2" className="text-center border-right">Revenue</th>


                                                                                <th className=" border-right text-center">Group</th>

                                                                                <th rowSpan="2" className="text-end border-right">CompSet Avg</th>
                                                                                <th rowSpan="2" className="text-center border-right">Demand Score</th>


                                                                                <th colSpan="4" className="text-center border-right">Forecast</th>
                                                                            </tr>


                                                                            <tr>
                                                                                <th className="width175">Stay Date</th>
                                                                                <th className="width100 border-right">OOO\Rooms Available</th>
                                                                                <th className="width75 text-center ">Left To sell</th>
                                                                                <th className="width75 text-center ">AVG LT</th>
                                                                                <th className="width75 text-center">On The Books</th>
                                                                                <th className="width50">Total OCC%</th>
                                                                                <th className="text-end">ADR</th>
                                                                                <th className="text-end border-right">Rev</th>
                                                                                <th className="text-end">RevPAR</th>
                                                                                <th className=" border-right">OTB\Block</th>
                                                                                <th className="text-end width150 border-right">ADR</th>
                                                                                <th className="text-center width150">Rooms</th>
                                                                                <th className="text-center">Occ %</th>
                                                                                <th className="text-end">Rev</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody id="forecastBody">
                                                                            {
                                                                                TransientForecastData.map((item, index) => {

                                                                                    let checkEvent = eventListRef.current?.filter((x) => {
                                                                                        let checkingDate = moment(item.staydate);
                                                                                        let startingDate = moment(x?.startDate);
                                                                                        let endingDate = moment(x?.endDate);
                                                                                        if (
                                                                                            checkingDate.isSameOrAfter(startingDate) &&
                                                                                            checkingDate.isSameOrBefore(endingDate)
                                                                                        ) {
                                                                                            return x;
                                                                                        }
                                                                                    });


                                                                                    return <tr>
                                                                                        <td>

                                                                                            <div className="d-flex gap-1">
                                                                                                <div className="d-flex gap-4">
                                                                                                    {item.staydate} {item.dow}
                                                                                                    <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                                                        {checkEvent?.length > 0 && (
                                                                                                            <img id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "ticket", item)}
                                                                                                                style={{ height: "11px", width: "11px" }}
                                                                                                                className="iconcolor"
                                                                                                                src={ticket}
                                                                                                                alt="ticket"
                                                                                                                onClick={() => {
                                                                                                                    selectedEventDateRef.current = item.staydate;
                                                                                                                    eventListPropsRef.current = checkEvent;
                                                                                                                    setShowTicketModal(true);
                                                                                                                }}
                                                                                                            />
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>


                                                                                        </td>
                                                                                        <td className="width100 border-right">
                                                                                            {item.OOO
                                                                                                ? commonService.formateRoom(
                                                                                                    item.OOO
                                                                                                )
                                                                                                : 0}{" "}
                                                                                            \{" "}
                                                                                            {item.RoomAvailable
                                                                                                ? commonService.formateRoom(
                                                                                                    item.RoomAvailable
                                                                                                )
                                                                                                : 0}
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            {item.LeftToSell
                                                                                                ? commonService.formateRoom(
                                                                                                    item.LeftToSell
                                                                                                )
                                                                                                : 0}
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            {item.avgleadtime
                                                                                                ? commonService.formateRoom(
                                                                                                    item.avgleadtime
                                                                                                )
                                                                                                : 0}
                                                                                        </td>
                                                                                        <td
                                                                                            className="text-primary text-center"
                                                                                            value={
                                                                                                item.OnTheBook
                                                                                                    ? commonService.formateRoom(
                                                                                                        item.OnTheBook
                                                                                                    )
                                                                                                    : 0
                                                                                            }
                                                                                        >
                                                                                            <span id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "transient-current-year-on-the-books", item)}
                                                                                                className={`${selectedTdIndexRef.current === index
                                                                                                    ? "singleDateSummarySpan"
                                                                                                    : ""
                                                                                                    }`}
                                                                                                onClick={(e) => {
                                                                                                    singleDateSelectedDateRef.current = item.staydate;

                                                                                                    handleFilterBtnClick(e);
                                                                                                    selectedTdIndexRef.current = index;
                                                                                                }}
                                                                                                style={{ cursor: "pointer" }}
                                                                                            >
                                                                                                {item.OnTheBook
                                                                                                    ? item.OnTheBook
                                                                                                    : 0}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td className={"perbackground TotalOCCPercentage"} value={item.TotalOCCPercentage
                                                                                            ? item.TotalOCCPercentage
                                                                                            : 0}>
                                                                                            {item.TotalOCCPercentage
                                                                                                ? item.TotalOCCPercentage
                                                                                                : 0}
                                                                                            %
                                                                                        </td>
                                                                                        <td
                                                                                            className="text-end"
                                                                                            value={item.ADR}
                                                                                        >
                                                                                            {item.ADR
                                                                                                ? commonService.formateAmount(
                                                                                                    item.ADR
                                                                                                )
                                                                                                : commonService.formateAmount(0)}
                                                                                        </td>
                                                                                        <td className="text-end border-right">
                                                                                            {item.REV
                                                                                                ? commonService.formateAmount(
                                                                                                    item.REV
                                                                                                )
                                                                                                : commonService.formateAmount(0)}
                                                                                        </td>
                                                                                        <td className="text-end">
                                                                                            {item.RevPAR
                                                                                                ? commonService.formateAmount(
                                                                                                    item.RevPAR
                                                                                                )
                                                                                                : commonService.formateAmount(0)}
                                                                                        </td>
                                                                                        <td
                                                                                            className="perbackground perbackground-GroupOTB border-right text-center text-primary"
                                                                                            value={commonService.FindPercentageOfValueMaxUpTo100(item.OTB, item.Block)}
                                                                                        >
                                                                                            <span id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "group-otb-block", item)}
                                                                                                className={`${selectedTdIndexRef.current === index
                                                                                                    ? "singleDateSummarySpan"
                                                                                                    : ""
                                                                                                    }`}
                                                                                                onClick={(e) => {
                                                                                                    singleDateSelectedDateRef.current = item.staydate;

                                                                                                    handleGroupBtnClick(e);
                                                                                                    selectedTdIndexRef.current = index;
                                                                                                }}
                                                                                                style={{ cursor: "pointer" }}
                                                                                            >
                                                                                                {item.OTB
                                                                                                    ? commonService.formateRoom(
                                                                                                        item.OTB
                                                                                                    )
                                                                                                    : 0}
                                                                                                \
                                                                                                {item.Block
                                                                                                    ? commonService.formateRoom(
                                                                                                        item.Block
                                                                                                    )
                                                                                                    : 0}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td className="text-end border-right">{commonService.formateAmount(item.compsetavg)}</td>
                                                                                        <td className="text-center border-right">{item.demandscore}</td>

                                                                                        {/* <td className="text-center">{item.roomsavailable}</td>*/}

                                                                                        <td className="text-end border-right">
                                                                                            <div class="from-groups no-border-break">
                                                                                                <input id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "forecast-adr", item)}
                                                                                                    className="form-control text-end"
                                                                                                    type="number"
                                                                                                    value={item.transientadr}
                                                                                                    onChange={(e) => handleChange(index, "transientadr", e.target.value)}
                                                                                                />
                                                                                            </div>

                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <div class="from-groups no-border-break">
                                                                                                <input id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "forecast-rooms", item)}
                                                                                                    className="form-control text-center"
                                                                                                    type="number"
                                                                                                    value={item.exptransientrooms}
                                                                                                    onChange={(e) => handleChange(index, "exptransientrooms", e.target.value)}
                                                                                                />
                                                                                            </div>

                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                        {item?.RoomAvailable
                                                                                            ? ((item.exptransientrooms || 0) / item.RoomAvailable * 100).toFixed(2)
                                                                                            : 0} %
                                                                                        </td>
                                                                                        {/* <td className="text-center">{item.fcstocc}%</td> */}
                                                                                        <td className="text-end">{commonService.formateAmount((item.exptransientrooms || 0) * (item.transientadr || 0))}</td>
                                                                                    </tr>
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                        <tfoot>
                                                                            <tr>
                                                                                <th>Total</th>

                                                                                <th className="boldTd border-right">
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.OOO)} \{" "}
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.RoomAvailable)}
                                                                                </th>
                                                                                <th className="boldTd text-center">
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.LeftToSell)}
                                                                                </th>
                                                                                <th className="boldTd text-center">
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.avgleadtime)}
                                                                                </th>
                                                                                <th className="boldTd text-center">
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.OnTheBook)}
                                                                                </th>
                                                                                <th className="boldTd">
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.TotalOCCPercentage)}%

                                                                                </th>
                                                                                <th className="boldTd text-end ">
                                                                                    {commonService.formateAmount(TransientForecastDataTotal.ADR)}
                                                                                </th>
                                                                                <th className="boldTd text-end border-right">
                                                                                    {commonService.formateAmount(TransientForecastDataTotal.REV)}
                                                                                </th>
                                                                                <th className="boldTd text-end">
                                                                                    {commonService.formateAmount(TransientForecastDataTotal.RevPAR)}
                                                                                </th>
                                                                                <th className="boldTd text-center border-right">
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.OTB)}/
                                                                                    {commonService.formateRoom(TransientForecastDataTotal.Block)}
                                                                                </th>

                                                                                <th className="text-center border-right"></th>
                                                                                <th className="text-center  border-right">{TransientForecastDataTotal.demandscore}</th>

                                                                                <th className="text-end">{commonService.formateAmount(TransientForecastDataTotal.transientadr)}</th>
                                                                                <th className="text-center">{TransientForecastDataTotal.exptransientrooms}</th>
                                                                                <th className="text-end  border-right"></th>
                                                                                <th className="text-end">{commonService.formateAmount(TransientForecastDataTotal.exptransientrev)}</th>
                                                                            </tr>
                                                                        </tfoot>
                                                                    </Table>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="action-button">
                                                        {/* <button className="btn btn-secondary" onClick={(e) => fnSetActiveTab(1)}>Back To Group Details</button> */}
                                                       {
                                                        showTabTwoContent &&
                                                        <button id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "calculate-displacement", "")} className="btn btn-primary" onClick={(e) => fnSetActiveTab(3)}>Calculate Displacement</button>
                                                        }
                                                    </div>
                                             </>
                                         </section>
                                        }                     
                                        {/* Tab 2 Content */}
                                        {
                                            !showTabTwoContent &&
                                        <div className="action-button mb-2">
                                            {
                                                DataLoading === true ?
                                                    <button className="default-btn primary-btn" type="button" disabled>
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                        Calculating...
                                                    </button>
                                                    :
                                                    <button id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "calculate-a-new-quote", "")} className="btn btn-primary" onClick={(e) => APICalling()}>Calculate a New Quote</button>
                                            }
                                        </div>
                                        }
                                    </section>
                                }

                                {/* {
                                    activeTab === 2 &&
                                    <section className="panel" id="panel2">
                                        <>
                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="card-title"> Transient Forecast (Stay Dates)</div>
                                                    <span className="confidence medium"><span className="confidence-dot"></span> From Forecast Engine</span>
                                                </div>
                                                <div className="card-body p-0">
                                                    <div className="ViewPropertySetupTable">
                                                        <div className="stripped__table">
                                                            <Table responsive id="tblTransientForecastStayDates">
                                                                <thead>

                                                                    <tr>
                                                                        <th className="width175"></th>

                                                                        <th colSpan="6" className="text-center border-right">TRANSIENT CURRENT YEAR</th>

                                                                        <th colSpan="2" className="text-center border-right">Revenue</th>


                                                                        <th className=" border-right text-center">Group</th>

                                                                        <th rowSpan="2" className="text-end border-right">CompSet Avg</th>
                                                                        <th rowSpan="2" className="text-center border-right">Demand Score</th>


                                                                        <th colSpan="4" className="text-center border-right">Forecast</th>
                                                                    </tr>


                                                                    <tr>
                                                                        <th className="width175">Stay Date</th>
                                                                        <th className="width100 border-right">OOO\Rooms Available</th>
                                                                        <th className="width75 text-center ">Left To sell</th>
                                                                        <th className="width75 text-center ">AVG LT</th>
                                                                        <th className="width75 text-center">On The Books</th>
                                                                        <th className="width50">Total OCC%</th>
                                                                        <th className="text-end">ADR</th>
                                                                        <th className="text-end border-right">Rev</th>
                                                                        <th className="text-end">RevPAR</th>
                                                                        <th className=" border-right">OTB\Block</th>
                                                                        <th className="text-center border-right">Occ %</th>
                                                                        <th className="text-end width150">ADR</th>
                                                                        <th className="text-center width150">Rooms</th>
                                                                        <th className="text-end">Rev</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody id="forecastBody">
                                                                    {
                                                                        TransientForecastData.map((item, index) => {

                                                                            let checkEvent = eventListRef.current?.filter((x) => {
                                                                                let checkingDate = moment(item.staydate);
                                                                                let startingDate = moment(x?.startDate);
                                                                                let endingDate = moment(x?.endDate);
                                                                                if (
                                                                                    checkingDate.isSameOrAfter(startingDate) &&
                                                                                    checkingDate.isSameOrBefore(endingDate)
                                                                                ) {
                                                                                    return x;
                                                                                }
                                                                            });


                                                                            return <tr>
                                                                                <td>

                                                                                    <div className="d-flex gap-1">
                                                                                        <div className="d-flex gap-4">
                                                                                            {item.staydate} {item.dow}
                                                                                            <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                                                {checkEvent?.length > 0 && (
                                                                                                    <img
                                                                                                        style={{ height: "11px", width: "11px" }}
                                                                                                        className="iconcolor"
                                                                                                        src={ticket}
                                                                                                        alt="ticket"
                                                                                                        onClick={() => {
                                                                                                            selectedEventDateRef.current = item.staydate;
                                                                                                            eventListPropsRef.current = checkEvent;
                                                                                                            setShowTicketModal(true);
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                </td>
                                                                                <td className="width100 border-right">
                                                                                    {item.OOO
                                                                                        ? commonService.formateRoom(
                                                                                            item.OOO
                                                                                        )
                                                                                        : 0}{" "}
                                                                                    \{" "}
                                                                                    {item.RoomAvailable
                                                                                        ? commonService.formateRoom(
                                                                                            item.RoomAvailable
                                                                                        )
                                                                                        : 0}
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    {item.LeftToSell
                                                                                        ? commonService.formateRoom(
                                                                                            item.LeftToSell
                                                                                        )
                                                                                        : 0}
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    {item.avgleadtime
                                                                                        ? commonService.formateRoom(
                                                                                            item.avgleadtime
                                                                                        )
                                                                                        : 0}
                                                                                </td>
                                                                                <td
                                                                                    className="text-primary text-center"
                                                                                    value={
                                                                                        item.OnTheBook
                                                                                            ? commonService.formateRoom(
                                                                                                item.OnTheBook
                                                                                            )
                                                                                            : 0
                                                                                    }
                                                                                >
                                                                                    <span
                                                                                        className={`${selectedTdIndexRef.current === index
                                                                                            ? "singleDateSummarySpan"
                                                                                            : ""
                                                                                            }`}
                                                                                        onClick={(e) => {
                                                                                            singleDateSelectedDateRef.current = item.staydate;

                                                                                            handleFilterBtnClick(e);
                                                                                            selectedTdIndexRef.current = index;
                                                                                        }}
                                                                                        style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        {item.OnTheBook
                                                                                            ? item.OnTheBook
                                                                                            : 0}
                                                                                    </span>
                                                                                </td>
                                                                                <td className={"perbackground TotalOCCPercentage"} value={item.TotalOCCPercentage
                                                                                    ? item.TotalOCCPercentage
                                                                                    : 0}>
                                                                                    {item.TotalOCCPercentage
                                                                                        ? item.TotalOCCPercentage
                                                                                        : 0}
                                                                                    %
                                                                                </td>
                                                                                <td
                                                                                    className="text-end"
                                                                                    value={item.ADR}
                                                                                >
                                                                                    {item.ADR
                                                                                        ? commonService.formateAmount(
                                                                                            item.ADR
                                                                                        )
                                                                                        : commonService.formateAmount(0)}
                                                                                </td>
                                                                                <td className="text-end border-right">
                                                                                    {item.REV
                                                                                        ? commonService.formateAmount(
                                                                                            item.REV
                                                                                        )
                                                                                        : commonService.formateAmount(0)}
                                                                                </td>
                                                                                <td className="text-end">
                                                                                    {item.RevPAR
                                                                                        ? commonService.formateAmount(
                                                                                            item.RevPAR
                                                                                        )
                                                                                        : commonService.formateAmount(0)}
                                                                                </td>
                                                                                <td
                                                                                    className="perbackground perbackground-GroupOTB border-right text-center text-primary"
                                                                                    value={commonService.FindPercentageOfValueMaxUpTo100(item.OTB, item.Block)}
                                                                                >
                                                                                    <span
                                                                                        className={`${selectedTdIndexRef.current === index
                                                                                            ? "singleDateSummarySpan"
                                                                                            : ""
                                                                                            }`}
                                                                                        onClick={(e) => {
                                                                                            singleDateSelectedDateRef.current = item.staydate;

                                                                                            handleGroupBtnClick(e);
                                                                                            selectedTdIndexRef.current = index;
                                                                                        }}
                                                                                        style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        {item.OTB
                                                                                            ? commonService.formateRoom(
                                                                                                item.OTB
                                                                                            )
                                                                                            : 0}
                                                                                        \
                                                                                        {item.Block
                                                                                            ? commonService.formateRoom(
                                                                                                item.Block
                                                                                            )
                                                                                            : 0}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end border-right">{commonService.formateAmount(item.compsetavg)}</td>
                                                                                <td className="text-center border-right">{item.demandscore}</td>

                                                                                <td className="text-center border-right">{item.fcstocc}%</td>


                                                                                <td className="text-end">
                                                                                    <div class="from-groups no-border-break">
                                                                                        <input
                                                                                            className="form-control text-end"
                                                                                            type="number"
                                                                                            value={item.transientadr}
                                                                                            onChange={(e) => handleChange(index, "transientadr", e.target.value)}
                                                                                        />
                                                                                    </div>

                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <div class="from-groups no-border-break">
                                                                                        <input
                                                                                            className="form-control text-center"
                                                                                            type="number"
                                                                                            value={item.exptransientrooms}
                                                                                            onChange={(e) => handleChange(index, "exptransientrooms", e.target.value)}
                                                                                        />
                                                                                    </div>

                                                                                </td>
                                                                                <td className="text-end">{commonService.formateAmount(item.exptransientrev)}</td>
                                                                            </tr>
                                                                        })
                                                                    }
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th>Total</th>

                                                                        <th className="boldTd border-right">
                                                                            {commonService.formateRoom(TransientForecastDataTotal.OOO)} \{" "}
                                                                            {commonService.formateRoom(TransientForecastDataTotal.RoomAvailable)}
                                                                        </th>
                                                                        <th className="boldTd text-center">
                                                                            {commonService.formateRoom(TransientForecastDataTotal.LeftToSell)}
                                                                        </th>
                                                                        <th className="boldTd text-center">
                                                                            {commonService.formateRoom(TransientForecastDataTotal.avgleadtime)}
                                                                        </th>
                                                                        <th className="boldTd text-center">
                                                                            {commonService.formateRoom(TransientForecastDataTotal.OnTheBook)}
                                                                        </th>
                                                                        <th className="boldTd">
                                                                            {commonService.formateRoom(TransientForecastDataTotal.TotalOCCPercentage)}%

                                                                        </th>
                                                                        <th className="boldTd text-end ">
                                                                            {commonService.formateAmount(TransientForecastDataTotal.ADR)}
                                                                        </th>
                                                                        <th className="boldTd text-end border-right">
                                                                            {commonService.formateAmount(TransientForecastDataTotal.REV)}
                                                                        </th>
                                                                        <th className="boldTd text-end">
                                                                            {commonService.formateAmount(TransientForecastDataTotal.RevPAR)}
                                                                        </th>
                                                                        <th className="boldTd text-center border-right">
                                                                            {commonService.formateRoom(TransientForecastDataTotal.OTB)}/
                                                                            {commonService.formateRoom(TransientForecastDataTotal.Block)}
                                                                        </th>

                                                                        <th className="text-center border-right"></th>
                                                                        <th className="text-center  border-right">{TransientForecastDataTotal.demandscore}</th>
                                                                        <th className="text-end  border-right"></th>

                                                                        <th className="text-end">{commonService.formateAmount(TransientForecastDataTotal.transientadr)}</th>
                                                                        <th className="text-center">{TransientForecastDataTotal.exptransientrooms}</th>
                                                                        <th className="text-end">{commonService.formateAmount(TransientForecastDataTotal.exptransientrev)}</th>
                                                                    </tr>
                                                                </tfoot>
                                                            </Table>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="action-button">
                                                <button className="btn btn-secondary" onClick={(e) => fnSetActiveTab(1)}>Back To Group Details</button>
                                                <button className="btn btn-primary" onClick={(e) => fnSetActiveTab(3)}>Calculate Displacement</button>
                                            </div>
                                        </>
                                    </section>
                                } */}

                                {
                                    activeTab === 3 &&

                                    <section className="panel" id="panel3">

                                        {
                                            Calculation.NETGROUPPROFITLOSS > 0 ?
                                                <div className="verdict-banner accept" id="verdictBanner">
                                                    <div className="verdict-icon" id="verdictIcon"><img src={Success} alt="" /></div>
                                                    <div>
                                                        <div className="verdict-title" id="verdictTitle">ACCEPT Group is profitable</div>
                                                        <div className="verdict-desc" id="verdictDesc">The group revenue including ancillary exceeds displaced transient revenue by {commonService.formateAmount(Calculation.NETGROUPPROFITLOSS)}.</div>
                                                    </div>
                                                    <div className="verdict-indicator">
                                                        <span className="confidence high" id="confidenceBadge"><span className="confidence-dot"></span> High Confidence</span>
                                                    </div>
                                                </div>
                                                :
                                                <div className="verdict-banner reject" id="verdictBanner">
                                                    <div className="verdict-icon" id="verdictIcon"><img src={Error} alt="" /></div>
                                                    <div>
                                                        <div className="verdict-title" id="verdictTitle">REJECT — Transient yields more revenue</div>
                                                        <div className="verdict-desc" id="verdictDesc">Accepting this group would result in a net loss of {commonService.formateAmount(Calculation.NETGROUPPROFITLOSS)} vs. transient</div>
                                                    </div>
                                                    <div className="verdict-indicator">
                                                        <span className="confidence high" id="confidenceBadge"><span className="confidence-dot"></span> High Confidence</span>
                                                    </div>
                                                </div>
                                        }




                                        <div className="stat-row" id="statRow">
                                            <div className="stat-card">
                                                <div className="stat-value gold" id="statGroupRate">{commonService.formateAmount(Calculation.ProposedGroupRate)}</div>
                                                <div className="stat-label">Proposed Group Rate</div>
                                                <div className="stat-sub">Avg price per room per night</div>
                                            </div>
                                            <div className="stat-card green">
                                                <div className="stat-value green" id="statRoomNights">{Calculation.GroupRoomNights}</div>
                                                <div className="stat-label">Room Nights</div>
                                                <div className="stat-sub" id="statDatesRange">{commonService.getDateInFormat(InputPara.checkindate)} to {commonService.getDateInFormat(InputPara.checkoutdate)} ({InputPara.numberofnights} Nights)</div>
                                            </div>
                                            <div className="stat-card blue">
                                                <div className={`stat-value  ${Calculation.NETGROUPPROFITLOSS > 0 ? "green" : "red"}`} id="statGroupProfit">{commonService.formateAmount(Calculation.NETGROUPPROFITLOSS)}</div>
                                                <div className="stat-label">Group Profit</div>
                                                <div className="stat-sub" id="statProfitSub">profit vs. displacement</div>
                                            </div>
                                            <div className="stat-card">
                                                <div className="stat-value gold" id="statDiscount">{Calculation.DiscountvsStandardPrice}%</div>
                                                <div className="stat-label">Discount vs Standard</div>
                                                <div className="stat-sub" id="statStdPrice">Standard: {commonService.formateAmount(Calculation.AvgTransientADRforDates)}</div>
                                            </div>
                                        </div>

                                        <div className="results-grid">

                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="card-title">Group Revenue</div>
                                                    <span className="totalGroupRevLabel">{commonService.formateAmount(Calculation.TotalGroupRevenueGross)}</span>
                                                </div>
                                                <div className="card-body p-0">

                                                    <div className="ViewPropertySetupTable">
                                                        <div className="stripped__table">

                                                            <Table responsive>

                                                                <tbody>
                                                                    <tr>
                                                                        <td>Room Revenue</td>
                                                                        <td className="text-end">{commonService.formateAmount(Calculation.TotalGroupRoomRevenue)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>F&B Revenue ({Calculation.GroupRoomNights} RN x {commonService.formateAmount(InputPara.fbrevroomnight)})</td>
                                                                        <td className="text-end">{commonService.formateAmount(Calculation.FAndBRevenue)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Meeting Room ({InputPara.numberofnights} nights x  {commonService.formateAmount(InputPara.meetingroomrevroomnight)})</td>
                                                                        <td className="text-end">{commonService.formateAmount(Calculation.MeetingRoomRevenue)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Ancillary Revenue ({Calculation.GroupRoomNights} RN x  {commonService.formateAmount(InputPara.ancillaryrevroomnight)})</td>
                                                                        <td className="text-end">{commonService.formateAmount(Calculation.AncillaryRevenue)}</td>
                                                                    </tr>
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th>Total Group Revenue</th>
                                                                        <th className="text-end">{commonService.formateAmount(Calculation.TotalGroupRevenueGross)}</th>
                                                                    </tr>
                                                                </tfoot>
                                                            </Table>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="card-title" > Displaced Transient Revenue</div>
                                                    <span className="totalDisplacedLabel">{commonService.formateAmount(Calculation.TotalDisplacedTransientRevenue)}</span>
                                                </div>
                                                <div className="card-body p-0" >
                                                    <div className="ViewPropertySetupTable">
                                                        <div className="stripped__table">

                                                            <Table responsive>

                                                                <tbody>
                                                                    <tr>
                                                                        <td>Displaced Room Revenue</td>
                                                                        <td className="text-end">{commonService.formateAmount(Calculation.DisplacedTransientRoomRevenue)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Displaced F&B Revenue</td>
                                                                        <td className="text-end">{commonService.formateAmount(Calculation.DisplacedFBRevenue)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Displaced Ancillary Revenue</td>
                                                                        <td className="text-end">{commonService.formateAmount(Calculation.DisplacedAncillaryTransient)}</td>
                                                                    </tr>

                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th>Total Displaced Revenue</th>
                                                                        <th className="text-end">{commonService.formateAmount(Calculation.TotalDisplacedTransientRevenue)}</th>
                                                                    </tr>
                                                                </tfoot>
                                                            </Table>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="card">
                                            <div className="card-header">
                                                <div className="card-title"> Net Displacement Impact</div>
                                            </div>
                                            <div className="card-body p-0">

                                                <div className="ViewPropertySetupTable">
                                                    <div className="stripped__table">
                                                        <Table responsive>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Group Revenue (Gross)</td>
                                                                    <td className="text-end">{commonService.formateAmount(Calculation.GroupRevenueGross)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Less: Displaced Transient Revenue</td>
                                                                    <td className="text-end negative">−({commonService.formateAmount(Calculation.LessDisplacedTransientRevenue)})</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Less: Group Acquisition Cost</td>
                                                                    <td className="text-end negative">−({commonService.formateAmount(Calculation.LessGroupAcquisitionCost)})</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Plus: Saved Transient Acq Cost</td>
                                                                    <td className="text-end positive ">+{commonService.formateAmount(Calculation.PlusSavedTransientAcquisitionCost)}</td>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th className={`${Calculation.NETGROUPPROFITLOSS > 0 ? "positive" : "negative"}`}>NET GROUP PROFIT / (LOSS)</th>
                                                                    <th className={`text-end ${Calculation.NETGROUPPROFITLOSS > 0 ? "positive" : "negative"}`}>{commonService.formateAmount(Calculation.NETGROUPPROFITLOSS)}</th>
                                                                </tr>
                                                            </tfoot>
                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="card">
                                            <div className="card-header">
                                                <div className="card-title"> Calculation Details</div>
                                            </div>
                                            <div className="card-body p-0" >
                                                <div className="ViewPropertySetupTable">
                                                    <div className="stripped__table">
                                                        <Table responsive>
                                                            <thead>
                                                                <tr>
                                                                    <th>Stay Date</th>
                                                                    <th className="text-center">Rooms Req.</th>
                                                                    {/* <th className="text-center">Rooms Avail</th> */}
                                                                    <th className="text-end">Standard Price</th>
                                                                    <th className="text-end">Displaced Transient Room Revenue</th>

                                                                    {/* <th className="text-end">Displaced Revenue</th> */}
                                                                    <th className="text-end">Total Displaced Revenue</th>
                                                                    <th className="text-end">Transient Acquisition Cost</th>
                                                                    {/* <th className="text-end">Rec. Group Price</th> */}
                                                                    <th className="text-end">Group Room Revenue</th>
                                                                    <th className="text-end">Total Group Revenue</th>
                                                                    <th className="text-end">Group Acquisition Cost</th>
                                                                    <th className="text-end">Group Profit/Loss</th>
                                                                    <th className="text-center">Demand Score</th>
                                                                    {/* <th className="text-end">Group Profit</th> */}
                                                                    <th className="text-center">Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody id="dayByDayBody">
                                                                {
                                                                    TransientForecastData.map((item) => {
                                                                        // let DisplacedRevenue = parseInt(((InputPara.numberofrooms * item.transientadr) * item.fcstocc) / 100)
                                                                        // let RecGroupPrice = InputPara.numberofrooms > 0 ? (DisplacedRevenue / InputPara.numberofrooms) : 0
                                                                        // let GroupProfit = (InputPara.proposedgrouprate - RecGroupPrice) * InputPara.numberofrooms;
                                                                        let tmp_fcstocc = item?.RoomAvailable ? ((item.exptransientrooms || 0) / item.RoomAvailable * 100).toFixed(2) : 0

                                                                        let roomsRequested = getRoomsForStayDate(item.dates);
                                                                        let DisplacedRevenue = parseInt(((roomsRequested * item.transientadr) * tmp_fcstocc) / 100)
                                                                        let RecGroupPrice = roomsRequested > 0 ? (DisplacedRevenue / roomsRequested) : 0
                                                                        let GroupProfit = (InputPara.proposedgrouprate - RecGroupPrice) * roomsRequested;

                                                                        // CalculationDetailsTotalRef.current.RoomsReq += InputPara.numberofrooms;
                                                                        CalculationDetailsTotalRef.current.RoomsReq += roomsRequested;
                                                                        CalculationDetailsTotalRef.current.StandardPrice += item.transientadr;
                                                                        // CalculationDetailsTotalRef.current.StandardPrice = CalculationDetailsTotalRef.current.StandardPrice / TransientForecastData.length;
                                                                        CalculationDetailsTotalRef.current.DisplacedRevenue += DisplacedRevenue;
                                                                        CalculationDetailsTotalRef.current.GroupProfit += GroupProfit;
                                                                        CalculationDetailsTotalRef.current.RecGroupPrice += CalculationDetailsTotalRef.current.RoomsReq > 0 ? (CalculationDetailsTotalRef.current.DisplacedRevenue / CalculationDetailsTotalRef.current.RoomsReq) : 0;


                                                                        let DisplacedTransientRoomRevenue = roomsRequested * item.transientadr
                                                                        CalculationDetailsTotalRef.current.DisplacedTransientRoomRevenue += DisplacedTransientRoomRevenue;

                                                                        let TotalDisplacedRevenue = DisplacedTransientRoomRevenue + (InputPara.fbrevroomnight + InputPara.ancillaryrevroomnight) * roomsRequested
                                                                        CalculationDetailsTotalRef.current.TotalDisplacedRevenue += TotalDisplacedRevenue;

                                                                        let TransientAcquisitionCost = TotalDisplacedRevenue * (InputPara.transientacquisitioncost / 100)
                                                                        CalculationDetailsTotalRef.current.TransientAcquisitionCost += TransientAcquisitionCost;

                                                                        let GroupRoomRevenue = roomsRequested * InputPara.proposedgrouprate
                                                                        CalculationDetailsTotalRef.current.GroupRoomRevenue += GroupRoomRevenue;

                                                                        let TotalGroupRevenue = GroupRoomRevenue + ((InputPara.fbrevroomnight + InputPara.ancillaryrevroomnight) * roomsRequested) + InputPara.meetingroomrevroomnight
                                                                        CalculationDetailsTotalRef.current.TotalGroupRevenue += TotalGroupRevenue;
                                                                         
                                                                        let GroupAcquisitionCost = TotalGroupRevenue * (InputPara.groupacquisitioncost / 100)
                                                                        CalculationDetailsTotalRef.current.GroupAcquisitionCost += GroupAcquisitionCost;

                                                                        let GroupProfitLoss = (TotalGroupRevenue - TotalDisplacedRevenue) + (TransientAcquisitionCost - GroupAcquisitionCost)
                                                                        CalculationDetailsTotalRef.current.GroupProfitLoss += GroupProfitLoss;

                                                                        return <tr>
                                                                            <td>{item.staydate} {item.dow}</td>
                                                                            {/* <td className="text-center">{InputPara.numberofrooms}</td> */}
                                                                            <td className="text-center">{roomsRequested}</td>
                                                                              {/* <td className="text-center">{item.roomsavailable}</td> */}
                                                                            <td className="text-end">{commonService.formateAmount(item.transientadr)}</td>
                                                                            
                                                                            <td className="text-end">{commonService.formateAmount(DisplacedTransientRoomRevenue)}</td>

                                                                            {/* <td className="text-end">{commonService.formateAmount(DisplacedRevenue)}</td> */}
                                                                            <td className="text-end">{commonService.formateAmount(TotalDisplacedRevenue)}</td>
                                                                            <td className="text-end">{commonService.formateAmount(TransientAcquisitionCost)}</td>
                                                                            <td className="text-end">{commonService.formateAmount(GroupRoomRevenue)}</td>
                                                                            <td className="text-end">{commonService.formateAmount(TotalGroupRevenue)}</td>
                                                                            <td className="text-end">{commonService.formateAmount(GroupAcquisitionCost)}</td>
                                                                            <td className={`text-end ${GroupProfitLoss > 0 ? "positive" : "negative"}`}>{commonService.formateAmount(GroupProfitLoss)}</td>
                                                                            <td className="text-center">{item?.demandscore ? item?.demandscore : 0}</td>
                                                                            <td className="text-center">{GroupProfitLoss > 0 ? <img src={Success} alt="PROFITABLE" /> : <img src={Error} alt="LOSS" />}</td>
                                                                            
                                                                            {/* <td className="text-end">{commonService.formateAmount(RecGroupPrice)}</td> */}
                                                                            {/* <td className={`text-end ${GroupProfit > 0 ? "positive" : "negative"}`}>{commonService.formateAmount(GroupProfit)}</td> */}
                                                                            {/* <td className="text-center">{GroupProfit > 0 ? <img src={Success} alt="PROFITABLE" /> : <img src={Error} alt="LOSS" />}</td> */}
                                                                        </tr>
                                                                    })
                                                                }
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th>Total</th>
                                                                    <th className="text-center">{CalculationDetailsTotalRef.current.RoomsReq}</th>
                                                                    {/* <th className="text-center"></th> */}
                                                                    <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.StandardPrice / TransientForecastData.length)}</th>
                                                                    
                                                                    <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.DisplacedTransientRoomRevenue)}</th>
                                                                    
                                                                    {/* <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.DisplacedRevenue)}</th> */}
                                                                    <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.TotalDisplacedRevenue)}</th>
                                                                    <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.TransientAcquisitionCost)}</th>
                                                                    <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.GroupRoomRevenue)}</th>
                                                                    <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.TotalGroupRevenue)}</th>
                                                                    <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.GroupAcquisitionCost)}</th>
                                                                    <th className={`text-end ${CalculationDetailsTotalRef.current.GroupProfitLoss > 0 ? "positive" : "negative"}`}>{commonService.formateAmount(CalculationDetailsTotalRef.current.GroupProfitLoss)}</th>
                                                                    <th className="text-center"></th>
                                                                    <th className={`text-center ${CalculationDetailsTotalRef.current.GroupProfitLoss > 0 ? "positive" : "negative"}`}>{CalculationDetailsTotalRef.current.GroupProfitLoss > 0 ? <span class="tag tag-accept">PROFITABLE</span> : <span class="tag tag-reject">LOSS</span>}</th>
                                                                    {/* <th className="text-end">{commonService.formateAmount(CalculationDetailsTotalRef.current.RecGroupPrice)}</th> */}
                                                                    {/* <th className={`text-end ${CalculationDetailsTotalRef.current.GroupProfit > 0 ? "positive" : "negative"}`}>{commonService.formateAmount(CalculationDetailsTotalRef.current.GroupProfit)}</th> */}
                                                                    {/* <th className={`text-center ${CalculationDetailsTotalRef.current.GroupProfit > 0 ? "positive" : "negative"}`}>{CalculationDetailsTotalRef.current.GroupProfit > 0 ? <span class="tag tag-accept">PROFITABLE</span> : <span class="tag tag-reject">LOSS</span>}</th> */}
                                                                </tr>
                                                            </tfoot>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                        <div className="action-button">
                                            <button id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "back-to-group-details", "")} className="btn btn-secondary" onClick={(e) => fnSetActiveTab(1)}>Back To Group Details</button>
                                            {/* <button className="btn btn-secondary" onClick={(e) => fnSetActiveTab(2)}>Back To Transient</button> */}
                                            <button id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "compare-scenarios", "")} className="btn btn-primary" onClick={(e) => fnSetActiveTab(4)}>Compare Scenarios</button>
                                        </div>
                                    </section>
                                }

                                {
                                    activeTab === 4 &&

                                    <section className="panel" id="panel4">

                                        <div className="card">
                                            <div className="card-header">
                                                <div className="card-title">Multi-Scenario Rate Comparison</div>
                                                <span >Compare up to 4 rate scenarios side-by-side</span>
                                            </div>
                                            <div className="card-body p-0">

                                                <div className="ViewPropertySetupTable">
                                                    <div className="stripped__table">
                                                        <Table responsive>
                                                            <thead>
                                                                <tr>
                                                                    <th>Metric</th>
                                                                    <th className="text-end">Scenario A</th>
                                                                    {/* <th className="text-end">Scenario D</th>
                                                                    <th className="text-end">Scenario B Discount (%)</th>
                                                                    <th className="text-end">Scenario C Discount (%)</th> */}
                                                                    <th className="text-end">Scenario B</th>
                                                                    <th className="text-end">Scenario C Discount (%)</th>
                                                                    <th className="text-end">Scenario D Discount (%)</th>
                                                                </tr>
                                                                <tr>
                                                                    <th></th>
                                                                    <th className="text-end"><span>At Transient ADR</span></th>
                                                                    <th className="text-end">
                                                                        {/* <input
                                                                            className="form-input"
                                                                            // type="number"
                                                                            id="discountShare"
                                                                            maxLength="3"
                                                                            min="0"
                                                                            max="100"
                                                                            value={InputPara.discountshare}
                                                                            onChange={(e) => {
                                                                                setInputPara({
                                                                                    ...InputPara,
                                                                                    discountshare: e.target.value ? parseInt(e.target.value) || 0 : "",
                                                                                });
                                                                            }}
                                                                        /> */}
                                                                    </th>
                                                                    <th className="text-end">
                                                                        <input id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "scenario-c-discount", "")} className="form-input"
                                                                            maxLength="3"
                                                                            value={MultiScenarioRateComparisonHeader.ScenarioBDiscount}
                                                                            onChange={(e) => {
                                                                                setMultiScenarioRateComparisonHeader({
                                                                                    ...MultiScenarioRateComparisonHeader,
                                                                                    ScenarioBDiscount: e.target.value ? parseInt(e.target.value) || 0 : "",
                                                                                });
                                                                            }}
                                                                        />
                                                                    </th>
                                                                    <th className="text-end">
                                                                        <input id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "scenario-d-discount", "")} className="form-input"
                                                                            maxLength="3"
                                                                            value={MultiScenarioRateComparisonHeader.ScenarioCDiscount}
                                                                            onChange={(e) => {
                                                                                setMultiScenarioRateComparisonHeader({
                                                                                    ...MultiScenarioRateComparisonHeader,
                                                                                    ScenarioCDiscount: e.target.value ? parseInt(e.target.value) || 0 : "",
                                                                                });
                                                                            }}
                                                                        />
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody id="scenarioBody">
                                                                <tr>
                                                                    <td>Proposed Group Rate</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.ProposedGroupRate.ScenarioA)}</td>
                                                                    <td className="text-end">
                                                                        <input id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "scenario-b", "")}
                                                                            className="form-input"
                                                                            type="number"
                                                                            value={MultiScenarioRateComparison.ProposedGroupRate.ScenarioD}
                                                                            onChange={(e) => {
                                                                                const newRate = e.target.value ? parseFloat(e.target.value) || 0 : 0;
                                                                                setInputPara({
                                                                                    ...InputPara,
                                                                                    discountshare: 0,
                                                                                    proposedgrouprate: newRate,
                                                                                });
                                                                            }}
                                                                            min="0"
                                                                        />
                                                                    </td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.ProposedGroupRate.ScenarioB)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.ProposedGroupRate.ScenarioC)}</td>
                                                                </tr>
                                                                <tr >
                                                                    <td>Group Room Revenue</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupRoomRevenue.ScenarioA)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupRoomRevenue.ScenarioD)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupRoomRevenue.ScenarioB)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupRoomRevenue.ScenarioC)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>F&B + Meeting + Ancillary</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.FAndBMeetingAncillary.ScenarioA)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.FAndBMeetingAncillary.ScenarioD)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.FAndBMeetingAncillary.ScenarioB)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.FAndBMeetingAncillary.ScenarioC)}</td>
                                                                </tr>
                                                                <tr >
                                                                    <td className="fw-bold">Total Group Revenue</td>
                                                                    <td className="text-end fw-bold">{commonService.formateAmount(MultiScenarioRateComparison.TotalGroupRevenue.ScenarioA)}</td>
                                                                    <td className="text-end fw-bold">{commonService.formateAmount(MultiScenarioRateComparison.TotalGroupRevenue.ScenarioD)}</td>
                                                                    <td className="text-end fw-bold">{commonService.formateAmount(MultiScenarioRateComparison.TotalGroupRevenue.ScenarioB)}</td>
                                                                    <td className="text-end fw-bold">{commonService.formateAmount(MultiScenarioRateComparison.TotalGroupRevenue.ScenarioC)}</td>
                                                                </tr><tr >
                                                                    <td>Displaced Transient Revenue</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.DisplacedTransientRevenue.ScenarioA)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.DisplacedTransientRevenue.ScenarioD)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.DisplacedTransientRevenue.ScenarioB)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.DisplacedTransientRevenue.ScenarioC)}</td>
                                                                </tr><tr >
                                                                    <td>Group Acquisition Cost</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupAcquisitionCost.ScenarioA)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupAcquisitionCost.ScenarioD)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupAcquisitionCost.ScenarioB)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.GroupAcquisitionCost.ScenarioC)}</td>
                                                                </tr><tr >
                                                                    <td>Saved Transient Acq Cost</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.SavedTransientAcqCost.ScenarioA)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.SavedTransientAcqCost.ScenarioD)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.SavedTransientAcqCost.ScenarioB)}</td>
                                                                    <td className="text-end">{commonService.formateAmount(MultiScenarioRateComparison.SavedTransientAcqCost.ScenarioC)}</td>
                                                                </tr>
                                                                <tr >
                                                                    <td className="fw-bold">Net Profit / (Loss)</td>
                                                                    <td className={`text-end fw-bold ${MultiScenarioRateComparison.NetProfitLoss.ScenarioA > 0 ? "positive " : "negative"}`}>{commonService.formateAmount(MultiScenarioRateComparison.NetProfitLoss.ScenarioA)}</td>
                                                                    <td className={`text-end fw-bold ${MultiScenarioRateComparison.NetProfitLoss.ScenarioD > 0 ? "positive " : "negative"}`}>{commonService.formateAmount(MultiScenarioRateComparison.NetProfitLoss.ScenarioD)}</td>
                                                                    <td className={`text-end fw-bold ${MultiScenarioRateComparison.NetProfitLoss.ScenarioB > 0 ? "positive " : "negative"}`}>{commonService.formateAmount(MultiScenarioRateComparison.NetProfitLoss.ScenarioB)}</td>
                                                                    <td className={`text-end fw-bold ${MultiScenarioRateComparison.NetProfitLoss.ScenarioC > 0 ? "positive " : "negative"}`}>{commonService.formateAmount(MultiScenarioRateComparison.NetProfitLoss.ScenarioC)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Discount vs Standard</td>
                                                                    <td className="text-end">{MultiScenarioRateComparison.DiscountvsStandard.ScenarioA}%</td>
                                                                    <td className="text-end">{MultiScenarioRateComparison.DiscountvsStandard.ScenarioD}%</td>
                                                                    <td className="text-end">{MultiScenarioRateComparison.DiscountvsStandard.ScenarioB}%</td>
                                                                    <td className="text-end">{MultiScenarioRateComparison.DiscountvsStandard.ScenarioC}%</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Verdict</td>
                                                                    <td className="text-end"><span className={`tag tag-${MultiScenarioRateComparison.Verdict.ScenarioA.toLowerCase()}`}>{MultiScenarioRateComparison.Verdict.ScenarioA}</span></td>
                                                                    <td className="text-end"><span className={`tag tag-${MultiScenarioRateComparison.Verdict.ScenarioD.toLowerCase()}`}>{MultiScenarioRateComparison.Verdict.ScenarioD}</span></td>
                                                                    <td className="text-end"><span className={`tag tag-${MultiScenarioRateComparison.Verdict.ScenarioB.toLowerCase()}`}>{MultiScenarioRateComparison.Verdict.ScenarioB}</span></td>
                                                                    <td className="text-end"><span className={`tag tag-${MultiScenarioRateComparison.Verdict.ScenarioC.toLowerCase()}`}>{MultiScenarioRateComparison.Verdict.ScenarioC}</span></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                        <div className="card" >
                                            <div className="card-header" >
                                                <div className="card-title" > Recommended Minimum Group Rate</div>
                                            </div>
                                            <div className="card-body">
                                                <div className="RecommendedMinimumGroupRate">
                                                    <div>
                                                        <div className="text">Breakeven (Room Only)</div>
                                                        <div className="value" id="breakevenRate">{commonService.formateAmount(MultiScenarioRateComparison.BreakevenRoomOnly)}</div>
                                                    </div>
                                                    <div>→</div>
                                                    <div>
                                                        <div className="text">With Ancillary Offset</div>
                                                        <div className="value" id="recMinRate">{commonService.formateAmount(MultiScenarioRateComparison.WithAncillaryOffset)}</div>
                                                    </div>
                                                    <div >→</div>
                                                    <div>
                                                        <div className="text">Your Proposed Rate</div>
                                                        <div className="value" id="proposedRateDisplay">{commonService.formateAmount(MultiScenarioRateComparison.YourProposedRate)}</div>
                                                    </div>
                                                </div>
                                                {/*<div className="RecommendedMinimumGroupNote">Your proposed rate of <strong>$130</strong> is below room-only breakeven ($139) but above the adjusted minimum of <strong>$84</strong>. The group is profitable when F&amp;B and meeting room revenue are factored in.</div>*/}
                                            </div>
                                        </div>

                                        <div className="action-button">
                                            <button id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "back-to-results", "")} className="btn btn-secondary" onClick={(e) => fnSetActiveTab(3)}>Back to Results</button>
                                            <button id={commonService.generateGlobalClickTrackerID("DisplacementCalc", "export-report", "")} className="btn btn-primary" onClick={(e) => printDiv()}>Export Report</button>
                                        </div>
                                    </section>
                                }
                            </div>
                        </Col>
                    </Row>

                </Container>
            ) : (
                <Container>
                    <div className="d-flex justify-content-center">
                        <h5>Please Select Property</h5>
                    </div>
                </Container>
            )}

            {widgetModal && (
                <Non_WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    non_widgetname={"Displacement Calculator"}
                />
            )}

            {
                ONTHEBOOKS.IsDisplay &&
                <Overlay
                    show={ONTHEBOOKS.IsDisplay}
                    target={ONTHEBOOKS.Target}
                    placement={ONTHEBOOKS.Position}
                >
                    <Popover
                        id="popover-contained"
                        className="SingleDateSummaryModalPopoverMain"
                        style={{ zIndex: 11 }}
                    >
                        <div className="horizontal-menu-option active">
                            <SingleDateSummaryModal
                                closeModal={closeSingleDate}
                                asOfDate={commonService.getDateInDBFormat(asOfDate)}
                                selectedDate={singleDateSelectedDateRef.current}
                                pickupDate={sevenMaxDateRef.current}
                                propertyDetail={{ propertyCode: propertyCode }}
                            />
                        </div>
                    </Popover>
                </Overlay>
            }


            {
                groupModal.IsDisplay &&
                <Overlay
                    show={groupModal.IsDisplay}
                    target={groupModal.Target}
                    placement={groupModal.Position}
                >
                    <Popover
                        id="popover-contained"
                        className="SingleDateSummaryModalPopoverMain"
                    >
                        <div className="horizontal-menu-option active singleDayGroupSummary">
                            <SingleDayGroupModal
                                closeModal={closeGroupDate}
                                asOfDate={commonService.getDateInDBFormat(asOfDate)}
                                selectedDate={singleDateSelectedDateRef.current}
                                propertyCode={propertyCode}
                            />
                        </div>
                    </Popover>
                </Overlay>
            }

            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventList}
                />
            )}

            <AddRoomDistributionModal
                showModal={showRoomDistributionModal}
                closeModal={closeRoomDistributionModal}
                numberofroomsArray={InputPara.numberofroomsArray}
                handleDateWiseRoomChange={handleDateWiseRoomChange}
                errorObj={InputPara.errorObj}
            />

        </div>
    );
};

export default DisplacementCalc;